export default "__VITE_PUBLIC_ASSET__113e69d0__"